"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._constructTemporalPlainDate = exports.getPlainDate = void 0;
var polyfill_1 = require("@js-temporal/polyfill");
var utils_1 = require("../util/utils");
/** @hidden */
function getPlainDate(plainDateInput) {
    if (typeof plainDateInput === 'string') {
        return (0, exports._constructTemporalPlainDate)(plainDateInput);
    }
    return plainDateInput._getTemporalPlainDate();
}
exports.getPlainDate = getPlainDate;
/** @hidden */
var _constructTemporalPlainDate = function (arg1, arg2, arg3) {
    if (typeof arg2 !== 'undefined' && typeof arg3 !== 'undefined') {
        if (typeof arg1 === 'object') {
            // add option to chain if invalid.
            throw new Error('invalid usage.');
        }
        var parsedYear = (0, utils_1.parseNum)(arg1);
        var parsedMonth = (0, utils_1.parseNum)(arg2);
        var parsedDay = (0, utils_1.parseNum)(arg3);
        if ([parsedYear, parsedMonth, parsedDay].some(function (n) { return isNaN(n); })) {
            throw new Error('invalid usage.');
        }
        var plainDate = new polyfill_1.Temporal.PlainDate(parsedYear, parsedMonth, parsedDay);
        return plainDate;
    }
    if (typeof arg2 !== 'undefined' || typeof arg3 !== 'undefined') {
        throw new Error('invalid usage.');
    }
    // single argument call - it's either a string or an object
    if (typeof arg1 === 'string') {
        var rx = /^\d{4}-([0][1-9]|1[0-2])-([0-2][1-9]|[1-3]0|3[01])$/;
        if (!rx.test(arg1)) {
            throw new Error('invalid usage.');
        }
        var dateParts = arg1.split('-').map(function (str) { return parseInt(str); });
        if (dateParts.some(function (n) { return isNaN(n); })) {
            if (!rx.test(arg1)) {
                throw new Error('invalid usage.');
            }
        }
        var year = dateParts[0], month = dateParts[1], day = dateParts[2];
        var plainDate = new polyfill_1.Temporal.PlainDate(year, month, day);
        return plainDate;
    }
    if (typeof arg1 === 'object' && arg1) {
        var year = arg1.year, month = arg1.month, day = arg1.day;
        var parsedYear = (0, utils_1.parseNum)(year);
        var parsedMonth = (0, utils_1.parseNum)(month);
        var parsedDay = (0, utils_1.parseNum)(day);
        if ([parsedYear, parsedMonth, parsedDay].some(function (n) { return isNaN(n); })) {
            throw new Error('invalid usage.');
        }
        var plainDate = new polyfill_1.Temporal.PlainDate(parsedYear, parsedMonth, parsedDay);
        return plainDate;
    }
    throw new Error('invalid usage.');
};
exports._constructTemporalPlainDate = _constructTemporalPlainDate;
//# sourceMappingURL=util.js.map